module.exports = __webpack_public_path__ + "static/image/sustainability/pc/image_compliance.ver2_0_2.jpg?5c443e05";